import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  Divider,
  Collapse,
  IconButton,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";

const RecruitFolders = ({ prospects, onFolderSelect }) => {
  const [open, setOpen] = useState({
    positions: true,
    years: true,
    custom: true,
  });

  const handleClick = (section) => {
    setOpen({
      ...open,
      [section]: !open[section],
    });
  };

  // Generate position folders
  const positions = [
    ...new Set(prospects.map((p) => p.position).filter(Boolean)),
  ];

  // Generate graduation year folders
  const years = [
    ...new Set(prospects.map((p) => p.graduationYear).filter(Boolean)),
  ].sort();

  // Generate position + year combinations
  const positionYearCombos = [];
  years.forEach((year) => {
    positions.forEach((position) => {
      const count = prospects.filter(
        (p) => p.position === position && p.graduationYear === year
      ).length;

      if (count > 0) {
        positionYearCombos.push({
          name: `${year} ${position}s`,
          filter: { position, graduationYear: year.toString() },
          count,
        });
      }
    });
  });

  return (
    <Paper sx={{ p: 2, height: "100%" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Recruit Folders
      </Typography>

      <List component="nav" dense>
        <ListItem button onClick={() => onFolderSelect({})}>
          <ListItemIcon>
            <FolderIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="All Recruits" />
        </ListItem>

        <Divider sx={{ my: 1 }} />

        {/* Position folders */}
        <ListItem button onClick={() => handleClick("positions")}>
          <ListItemIcon>
            {open.positions ? (
              <FolderOpenIcon color="primary" />
            ) : (
              <FolderIcon color="primary" />
            )}
          </ListItemIcon>
          <ListItemText primary="By Position" />
          {open.positions ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={open.positions} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {positions.map((position) => {
              const count = prospects.filter(
                (p) => p.position === position
              ).length;
              return (
                <ListItem
                  button
                  key={position}
                  sx={{ pl: 4 }}
                  onClick={() => onFolderSelect({ position })}
                >
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={`${position}s (${count})`} />
                </ListItem>
              );
            })}
          </List>
        </Collapse>

        {/* Graduation Year folders */}
        <ListItem button onClick={() => handleClick("years")}>
          <ListItemIcon>
            {open.years ? (
              <FolderOpenIcon color="primary" />
            ) : (
              <FolderIcon color="primary" />
            )}
          </ListItemIcon>
          <ListItemText primary="By Graduation Year" />
          {open.years ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={open.years} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {years.map((year) => {
              const count = prospects.filter(
                (p) => p.graduationYear === year
              ).length;
              return (
                <ListItem
                  button
                  key={year}
                  sx={{ pl: 4 }}
                  onClick={() =>
                    onFolderSelect({ graduationYear: year.toString() })
                  }
                >
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={`Class of ${year} (${count})`} />
                </ListItem>
              );
            })}
          </List>
        </Collapse>

        {/* Position + Year combinations */}
        <ListItem button onClick={() => handleClick("custom")}>
          <ListItemIcon>
            {open.custom ? (
              <FolderOpenIcon color="primary" />
            ) : (
              <FolderIcon color="primary" />
            )}
          </ListItemIcon>
          <ListItemText primary="Position by Class" />
          {open.custom ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={open.custom} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {positionYearCombos.map((combo) => (
              <ListItem
                button
                key={`${combo.filter.graduationYear}-${combo.filter.position}`}
                sx={{ pl: 4 }}
                onClick={() => onFolderSelect(combo.filter)}
              >
                <ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={`${combo.name} (${combo.count})`} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </List>
    </Paper>
  );
};

export default RecruitFolders;
